module.exports = __webpack_public_path__ + "src/img/uploadError.7a1898b4.png";